export const TICKET_STATUSES = [
  {
    value: "Open",
    label: "Në pritje",
    backgroundColor: "#FCC94A",
    color: "#1d3943",
  },
  {
    value: "InProgress",
    label: "Në proces",
    backgroundColor: "#3B82F6",
    color: "#FBFBFB",
  },
  {
    value: "WaitingOnEmployee",
    label: "Pret përgjigje",
    backgroundColor: "#F97316",
    color: "#FBFBFB",
  },
  {
    value: "Completed",
    label: "Zgjidhur",
    backgroundColor: "#1da193",
    color: "#FBFBFB",
  },
];

const BY_VALUE = TICKET_STATUSES.reduce((acc, status) => {
  acc[status.value] = status;
  return acc;
}, {});

export function getTicketStatusMeta(status) {
  return (
    BY_VALUE[status] || {
      value: status || "Open",
      label: status || "Në pritje",
      backgroundColor: "#9CA3AF",
      color: "#111827",
    }
  );
}

export function ticketStatusLabel(status) {
  return getTicketStatusMeta(status).label;
}

export function ticketStatusStyle(status) {
  const meta = getTicketStatusMeta(status);
  return {
    backgroundColor: meta.backgroundColor,
    color: meta.color,
  };
}

export function stripHtmlToText(htmlOrText) {
  return String(htmlOrText || "")
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function toMessagePreview(htmlOrText, max = 120) {
  const text = stripHtmlToText(htmlOrText);
  if (!text) return "";
  return text.length > max ? `${text.slice(0, max)}…` : text;
}

/** Build messages for UI; synthesize first bubble from description when missing. */
export function getTicketMessages(ticket) {
  if (Array.isArray(ticket?.messages) && ticket.messages.length > 0) {
    return ticket.messages;
  }
  if (!ticket?.ticketDescription && !ticket?.createdAt) return [];
  return [
    {
      messageId: `legacy-${ticket.ticketId}`,
      authorId: ticket.employeeId || "",
      authorName: ticket.createdBy || "",
      authorRole: "employee",
      body: ticket.ticketDescription || "",
      createdAt: ticket.createdAt || Date.now(),
      attachments: [],
    },
  ];
}

export const ACCESS_RIGHTS = ["Admin", "Super Admin", "Supervisor"];

export function isElevatedRole(userRole) {
  return ACCESS_RIGHTS.includes(userRole);
}
